module.exports = __webpack_public_path__ + "img/guinea.09e817da.svg";